import addError from '../../../utils/error.jsx';
import { request as openRequest } from '../actions/open';

export function request(customerId, paymentMethodId) {
    customerId = parseInt(customerId, 10);

    return {
        type: 'CUSTOMERS_REMOVE_PAYMENT_METHOD_REQUEST',
        customerId,
        paymentMethodId
    };
}

export function error(customerId, errors) {
    addError(errors);

    customerId = parseInt(customerId, 10);

    return {
        type: 'CUSTOMERS_REMOVE_PAYMENT_METHOD_ERROR',
        customerId,
        errors
    };
}

export function finish(customerId) {
    return dispatch => {
        dispatch(openRequest(customerId));

        return {
            type: 'CUSTOMERS_REMOVE_PAYMENT_METHOD_FINISH',
            customerId
        };
    };
}
